module.exports = __webpack_public_path__ + "static/artefact-381ceb5dae7cbbee588c58eef2d3212f.png";